import React, { useState, useEffect } from 'react';
import { Dialog } from '@tencent/spaui';
import { currentVersion } from './currentVersion';

export const withVersionUpdateDialog = (Component) => (props) => {
  const WithVersionComponent = (props) => {
    const [version, setVersion] = useState('');
    let ignore = false;
    // 一小时内更新过，不再更新
    if (localStorage.getItem('versionUpdateTime') && (Date.now()-localStorage.getItem('versionUpdateTime'))<60*60*1000) {
        ignore = true;
    }
    const [ignoreUpdate, setIgnore] = useState(ignore);
    useEffect(() => {
        // 间隔3分钟查看一次版本是否为最新，如果不是，提示用户更新
        setInterval(() => {
            getVersionFromWuji();
        }, 60000);
        
        console.log(`currentVersion is ${currentVersion}`);
    }, []);
    const getVersionFromWuji = () => {
        const wuji = `https://node.video.qq.com/x/api/wuji_public/object?appid=leadswebtest&schemaid=leads_web_version&schemakey=4d773413c34f4e52a477cdc228d07542&accountId=${window.pageProps.uid}`;
        
        console.log(`currentVersion is ${currentVersion}`);
        fetch(wuji)
        .then((response) => response.json())
        .then((res) => {
            setVersion(res.data[0]['version']);
        })
        .catch((e) => console.log('Oops, error', e));
    };
    const handleClose = () => {
        setIgnore(true);
    };
    const handleRefresh = () => {
        document.location.reload();
        localStorage.setItem('versionUpdateTime', Date.now());
    };
    const currentVersionStr = currentVersion.toString().replace(/"/g, "");
    return (
        <div>
            <Component {...props} version={version} />
            {version !='' && version > currentVersionStr && <Dialog
                style={{ width: 600 }}
                title='重要提醒'
                submitLabel='刷新'
                show={!ignoreUpdate}
                onClose={handleClose}
                onSubmit={handleRefresh}
                onCancel={handleClose}
            >
                <div>线索通版本已更新，请刷新页面</div>
            </Dialog>}
        </div>
    );
  };
  WithVersionComponent.displayName = 'MyComponent';
  return <WithVersionComponent {...props} />;
};